import React, { useState } from 'react';

const HashtagInput = ({ hashtags = [], onChange, maxTags = 10 }) => {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    let value = e.target.value;
    
    // Remove # prefix if user types it
    if (value.startsWith('#')) {
      value = value.slice(1);
    }
    
    setInputValue(value);
    setError('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',' || e.key === ' ') {
      e.preventDefault();
      addHashtag();
    } else if (e.key === 'Backspace' && inputValue === '' && hashtags.length > 0) {
      // Remove last hashtag when backspace is pressed on empty input
      removeHashtag(hashtags.length - 1);
    }
  };

  const addHashtag = () => {
    const tag = inputValue.trim().toLowerCase();
    
    if (!tag) return;

    // Validation
    if (hashtags.length >= maxTags) {
      setError(`Maximum ${maxTags} hashtags allowed`);
      return;
    }

    if (tag.length > 30) {
      setError('Hashtag must be 30 characters or less');
      return;
    }

    if (!/^[a-zA-Z0-9]+$/.test(tag)) {
      setError('Hashtags can only contain letters and numbers');
      return;
    }

    if (hashtags.some(t => t.toLowerCase() === tag)) {
      setError('Hashtag already added');
      return;
    }

    onChange([...hashtags, tag]);
    setInputValue('');
    setError('');
  };

  const removeHashtag = (index) => {
    const newTags = hashtags.filter((_, i) => i !== index);
    onChange(newTags);
    setError('');
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <label style={{
        display: 'block',
        color: 'var(--text-primary)',
        fontSize: '14px',
        fontWeight: '600',
        marginBottom: '8px'
      }}>
        Hashtags (Optional)
        <span style={{
          color: 'var(--text-secondary)',
          fontSize: '12px',
          fontWeight: '400',
          marginLeft: '8px'
        }}>
          {hashtags.length}/{maxTags}
        </span>
      </label>

      {/* Display existing hashtags */}
      {hashtags.length > 0 && (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          marginBottom: '12px'
        }}>
          {hashtags.map((tag, index) => (
            <div
              key={index}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '6px 12px',
                background: 'linear-gradient(135deg, var(--btn-secondary), var(--btn-secondary-hover))',
                color: 'white',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '500',
                gap: '8px',
                animation: 'fadeInUp 0.3s ease-out'
              }}
            >
              <span>#{tag}</span>
              <button
                type="button"
                onClick={() => removeHashtag(index)}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Input field */}
      <div style={{ position: 'relative' }}>
        <div style={{
          position: 'absolute',
          left: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--text-secondary)',
          fontSize: '16px',
          fontWeight: '600',
          pointerEvents: 'none'
        }}>
          #
        </div>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onBlur={addHashtag}
          placeholder="gaming, indie, multiplayer..."
          disabled={hashtags.length >= maxTags}
          style={{
            width: '100%',
            padding: '10px 10px 10px 28px',
            border: `2px solid ${error ? 'var(--btn-danger)' : 'var(--border-color)'}`,
            borderRadius: '8px',
            fontSize: '14px',
            background: hashtags.length >= maxTags ? 'var(--bg-secondary)' : 'var(--bg-card)',
            color: 'var(--text-primary)',
            outline: 'none',
            transition: 'all 0.3s ease',
            opacity: hashtags.length >= maxTags ? 0.6 : 1
          }}
        />
      </div>

      {/* Error message */}
      {error && (
        <div style={{
          color: 'var(--btn-danger)',
          fontSize: '12px',
          marginTop: '6px',
          animation: 'fadeInUp 0.3s ease-out'
        }}>
          {error}
        </div>
      )}

      {/* Helper text */}
      <div style={{
        color: 'var(--text-secondary)',
        fontSize: '12px',
        marginTop: '6px'
      }}>
        Press Enter, Space, or Comma to add. Letters and numbers only.
      </div>
    </div>
  );
};

export default HashtagInput;
